import { useContext } from "react";
import { PolicyNumberContext } from "../../components/PolicyNumberProvider";

export const usePolicyNumber = () => {
  const policyNumber = useContext(PolicyNumberContext);

  if (policyNumber === null) {
    throw new Error("usePolicyNumber must be used within a PolicyNumberProvider");
  }

  return policyNumber;
};

export default usePolicyNumber;
